<template>
  <section>
    <Title title="News" sub-title="最新消息" />
    <el-row :gutter="20">
      <el-col v-for="(item) in news" :key="item.id" :xs="24" :sm="12" :md="8">
        <NewsItem :data-source="item" />
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-pagination
        layout="prev, pager, next"
        :page-size="pages.limit"
        :total="pages.total"
        @current-change="handleChangePage"
      />
    </el-row>
  </section>
</template>
<script>
import Title from '@/components/Title'
import NewsItem from './NewsItem.vue'
import api from '@/api'

export default {
  components: {
    Title,
    NewsItem
  },
  data() {
    return {
      news: [],
      pages: {
        total: 0,
        page: 1,
        limit: 12
      }
    }
  },
  mounted() {
    this.getArticle()
  },
  methods: {
    async getArticle() {
      const params = {
        page: this.pages.page,
        limit: this.pages.limit
      }
      const { data, success } = await api.article.list(params)
      if (success) {
        this.news = data.records
        this.pages.total = data.total
      }
    },
    handleChangePage(page) {
      this.pages.page = page
      this.getArticle()
    }
  }
}
</script>
<style scoped lang="scss">
.title {
  text-align: left;
  @include minWidth992 {
    padding-left: 40px;
  }
}

::v-deep.el-pager li {
  font-size: 20px;
}

::v-deep.el-pagination   {
  .btn-prev, .btn-next {
    font-size: 18px;
  }
}

::v-deep.el-pager li, ::v-deep.el-pagination button:disabled, ::v-deep.el-pagination .btn-next, ::v-deep.el-pagination .btn-prev {
  background-color: transparent;
}
::v-deep.el-pager li.active, ::v-deep.el-pager li:hover {
  color: $mainPurple;
}
</style>
